export default "__VITE_ASSET__BXlDRQmh__"